const UnderConstructionOverlay = () => {
  return null;
};

export default UnderConstructionOverlay;
